import { WorksFilters, EMPTY_WORKS_FILTERS } from "../types/work-filters";

export const clearWorksFilters = (): WorksFilters => ({
  ...EMPTY_WORKS_FILTERS,
});

export const hasActiveWorksFilters = (filters: WorksFilters) => {
  return (
    filters.customerIds.length > 0 ||
    filters.workName.length > 0 ||
    filters.userIds.length > 0 ||
    filters.workStatuses.length > 0 ||
    filters.worktypeIds.length > 0 ||
    filters.startDates.length > 0 ||
    filters.dueDates.length > 0 ||
    !!filters.fromDate ||
    !!filters.toDate
  );
};
